import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";

const defaultCreateAppBody = {
    headers: {
        normalizedNames: {},
        lazyUpdate: null,
        lazyInit: null,
        headers: {},
    },
};

/** Resolves vendor user code for generateApp (code, else encryptedCode). */
const vendorTargetCode = (vendorUser) => {
    if (!vendorUser) return "";
    const code = vendorUser.code != null ? String(vendorUser.code).trim() : "";
    if (code) return code;
    return vendorUser.encryptedCode != null
        ? String(vendorUser.encryptedCode).trim()
        : "";
};

const authRequestConfig = {
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
    },
};

/** Vendor permission APIs are enabled only when window.envType === "DEV". */
const isVendorPermissionsDevEnv = () => window.envType === "DEV";

const requireDevEnvForVendorPermissions = () => {
    if (!isVendorPermissionsDevEnv()) {
        toaster("error", "Vendor permissions are available in DEV environment only.");
        return false;
    }
    return true;
};

/** Reads API error message from axios response, or returns fallback text. */
const apiMessage = (err, fallback) =>
    (err && err.response && err.response.data && err.response.data.message) ||
    fallback;

/**
 * POST api/v1/auth/generateApp — assign permissions to a vendor (Generate Permission flow).
 */
export const createApp = (options, onSuccess) => (dispatch) => {
    if (options && options.vendorUser && !requireDevEnvForVendorPermissions()) {
        return;
    }

    dispatch({ type: actionType.LOADER_TRUE });
    const body =
        options && options.vendorUser
            ? {
                permissions: options.permissions || [],
                targetUserCode: vendorTargetCode(options.vendorUser),
            }
            : defaultCreateAppBody;

    axios
        .post(`${apiConstants().AUTH_API_URL}api/v1/auth/generateApp`, body, authRequestConfig)
        .then((res) => {
            dispatch({ type: actionType.LOADER_FALSE });
            if (res.data && res.data.body) {
                dispatch({
                    type: actionType.CREATEAPP,
                    data: res.data.body,
                });
                toaster("success", res.data.message);
                if (onSuccess) {
                    onSuccess(res.data.body);
                }
            } else {
                toaster("error", res.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: actionType.LOADER_FALSE });
            toaster("error", apiMessage(err, "Failed to generate app permissions"));
        });
};

/**
 * PUT api/v1/auth/vendor/permissions?vendorCode=…
 * Body: { permissions: string[] } — same shape as auth API / curl.
 */


export const updateVendorPermissions = ((vendorCode, permissions, onSuccess) => (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios
      .put(`${apiConstants().AUTH_API_URL}api/v1/auth/vendor/permissions?vendorCode=${vendorCode}`, { permissions: permissions }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.data.status === "OK") {
          toaster("success", res.data.message);
          if (onSuccess) {
            onSuccess();
          }
        } else if (res.data.status === "BAD_REQUEST") {
          toaster("error", res.data.message);
        } else if (res.data.status === "NOT_FOUND") {
          toaster("error", res.data.message);
        }
      })
      .catch((err) => {
        toaster("error", apiMessage(err, "Failed to update vendor permissions"));
      });
  });